import { resultsConfigSelector, quoteFormSelector } from 'ctm-selectors';
import { getMultiLevelSortCriteria } from 'ctm-util-functions/lib/multi_sorting_config';

const showFiltersUpdateButton = (dispatch) => {
    dispatch({
        type: 'SET_RESULTS_CONFIG_VALUES',
        actions: [
            {
                key: 'filters.showFiltersUpdateButton',
                value: true
            }
        ]
    });
};

// eslint-disable-next-line valid-jsdoc
/**
 * The first rendering:
 *  - stagedValue is 800
 *  - selectedValue is 800
 * Changed without commit
 *  - stagedValue is the changed value (700)
 *  - selectedValue is the prev value (800)
 * if Commit
 *  - stagedValue is 700
 *  - selectedValue is 700
 * if Undo
 *  - stagedValue is 800
 *  - selectedValue is 800
 */
const excessStateMapping = (state) => {
    const stagedValue = resultsConfigSelector(state).getIn('helpers.filters.requestedExcess'.split('.'));
    const selectedValue = resultsConfigSelector(state).getIn('filters.requestedExcess'.split('.'));
    // vertical.quote.results.config.helpers.filters.coverType
    // 'vertical', 'quote', 'form', 'coverDetail', 'requestedExcess']
    const coverTypeSelectedValue = resultsConfigSelector(state).getIn('helpers.filters.coverType'.split('.'));
    const disabled = coverTypeSelectedValue && ['TPFT', 'TPPD'].includes(coverTypeSelectedValue);
    return {
        stagedValue,
        disabled,
        selectedValue
    };
};

const excessDispatchMapping = (dispatch) => ({
    stageChange: (filterValue) => {
        if (filterValue) {
            dispatch({
                type: 'SET_FILTER_VALUE',
                filter: 'requestedExcess',
                filterStaged: true,
                filterValue
            });
        } else {
            dispatch({
                type: 'SET_EXCESS_BY_STATE_FILTER',
                filter: 'requestedExcess',
                filterStaged: true
            });
        }
        dispatch({
            type: 'SET_FILTER_ACTION',
            resultsStateKey: 'filters.requestedExcess',
            resultsStagedStateKey: 'helpers.filters.requestedExcess',
            formStateKey: 'coverDetail.requestedExcess'
        });
    },
    showFiltersUpdateButton: () => showFiltersUpdateButton(dispatch),
    ...updateResultsDispatchMapping(dispatch)
});

const updateResultsStateMapping = (state) => {
    // vertical.quote.results.config.filters.showFiltersUpdateButton
    const resultsStagedStateKey = 'filters.showFiltersUpdateButton';
    const isShowFiltersUpdateButton = resultsConfigSelector(state).getIn(resultsStagedStateKey.split('.'));
    return {
        isShowFiltersUpdateButton
    };
};

const updateResultsDispatchMapping = (dispatch) => ({
    applyUpdateResults: (reload = false) => {
        dispatch({
            type: 'ACTIVATE_STAGED_FILTERS'
        });
        dispatch({
            type: 'SET_RESULTS_CONFIG_VALUES',
            actions: [
                {
                    key: 'filterDisplayMode',
                    value: ''
                },
                {
                    key: 'filters.showFiltersUpdateButton',
                    value: false
                }
            ]

        });
        dispatch({
            type: 'SET_PAGE_VALUE',
            identifier: 'lastViewedPage',
            value: 'results'
        });
        if (reload) {
            dispatch({
                type: 'SET_PAGE_VALUE',
                identifier: 'doReload',
                value: true
            });
        }
    },
    undoStaged: () => {
        dispatch({
            type: 'CANCEL_STAGED_FILTERS'
        });
    }
});

// eslint-disable-next-line valid-jsdoc
/**
 * The first rendering:
 *  - initialFormValue has value (COMPREHENSIVE)
 *  - stagedValue is undefined
 *  - selectedValue is undefined
 * Changed without commit
 *  - initialFormValue is prev value (COMPREHENSIVE)
 *  - stagedValue is the changed value (TPFT)
 *  - selectedValue is the changed value (TPFT)
 * if Commit
 *  - initialFormValue is prev value (TPFT)
 *  - stagedValue is the changed value (TPFT)
 *  - selectedValue is the changed value (TPFT)
 * if Undo
 *  - initialFormValue is prev value (COMPREHENSIVE)
 *  - stagedValue is the changed value (COMPREHENSIVE)
 *  - selectedValue is the changed value (COMPREHENSIVE)
 * /
 * The second rendering on changed cover type to TPFT:
 *  - initialFormValue has value (TPFT)
 *  - stagedValue is the previous value COMPREHENSIVE
 */
const coverTypeStateMapping = (state) => {
    const initialFormValue = quoteFormSelector(state).getIn('coverDetail.coverType'.split('.'));
    const stagedValue = resultsConfigSelector(state).getIn('helpers.filters.coverType'.split('.'));
    // pristineValue is the current value when the page was first loaded
    const pristineValue = resultsConfigSelector(state).getIn('filters.coverType'.split('.'));

    return {
        stagedValue: stagedValue || initialFormValue,
        pristineValue
    };
};

const coverTypeDispatchMapping = (dispatch) => ({
    stageChange: (filterValue) => {
        dispatch({
            type: 'SET_FILTER_VALUE',
            filter: 'coverType',
            filterStaged: true,
            filterValue
        });
        dispatch({
            type: 'SET_FILTER_ACTION',
            resultsStateKey: 'filters.coverType',
            resultsStagedStateKey: 'helpers.filters.coverType',
            formStateKey: 'coverDetail.coverType'
        });
        showFiltersUpdateButton(dispatch);
        // special cover relative changes
        if (filterValue === 'TPFT' || filterValue === 'TPPD') {
            dispatch({
                type: 'SET_FILTER_VALUE',
                filter: 'requestedExcess',
                filterStaged: true,
                filterValue: '600'
            });
            dispatch({
                type: 'SET_FILTER_ACTION',
                resultsStateKey: 'filters.requestedExcess',
                resultsStagedStateKey: 'helpers.filters.requestedExcess',
                formStateKey: 'coverDetail.requestedExcess'
            });
        } else if (filterValue === 'COMPREHENSIVE') {
            dispatch({
                type: 'SET_EXCESS_BY_STATE_FILTER',
                filter: 'requestedExcess',
                filterStaged: true
            });
            dispatch({
                type: 'SET_FILTER_ACTION',
                resultsStateKey: 'filters.requestedExcess',
                resultsStagedStateKey: 'helpers.filters.requestedExcess',
                formStateKey: 'coverDetail.requestedExcess'
            });
        }
    }
});

const paymentFrequencyStateMapping = (state) => {
    const selectedValue = resultsConfigSelector(state).getIn(['filters', 'frequency']);
    return {
        frequencyFilter: selectedValue
    };
};

const paymentFrequencyDispatchMapping = (dispatch) => ({
    sortResults: (frequency) => {
        dispatch({
            type: 'SORT_RESULTS',
            sortBy: `productMeta.price.${frequency}Premium`,
            sortDir: 'asc',
            sortType: 'numeric'
        });
    },
    sortArrayMultiLevel: (frequency) => {
        dispatch({
            type: 'SORT_ARRAY_MULTI_LEVEL',
            sortCriteria: getMultiLevelSortCriteria(frequency)
        });
    },
    setFrequencyFilter: (frequency) => {
        dispatch({
            type: 'SET_FILTER_VALUE',
            filter: 'frequency',
            filterValue: frequency
        });
    },
    stageChange: (filterValue) => {
        dispatch({
            type: 'SET_FILTER_VALUE',
            filter: 'frequency',
            filterStaged: true,
            filterValue
        });
        dispatch({
            type: 'SET_FILTER_ACTION',
            resultsStateKey: 'filters.frequency',
            resultsStagedStateKey: 'helpers.filters.frequency',
            formStateKey: 'coverDetail.frequency'
        });
    }
});

const frequencyFilterTypes = ['monthly', 'annual'];

export {
    excessStateMapping, excessDispatchMapping,
    coverTypeStateMapping, coverTypeDispatchMapping,
    paymentFrequencyStateMapping, paymentFrequencyDispatchMapping,
    updateResultsStateMapping, updateResultsDispatchMapping,

    frequencyFilterTypes
};
